import CollageServices from '@/services-ts/Post/CollageServices'
import CommunityServices from '@/services-ts/Post/CommunityServices'
import PostFilterServices from '@/services-ts/Post/PostFilterServices'
import PostServices from '@/services-ts/Post/PostServices'

const PostAPI = (apiPost: string) => {
  return {
    PostServices: new PostServices(apiPost),
    CommunityServices: new CommunityServices(apiPost),
    CollageServices: new CollageServices(apiPost),
    PostFilterServices: new PostFilterServices(apiPost),
  }
}

export default PostAPI
